import update from 'immutability-helper'
import values from 'lodash/values'

class DesktopNotificationsHandler {
  constructor () {
    this.notifications = {}
    this.NotificationHandler = window.Notification
  }

  hasSupport () {
    return this.NotificationHandler ? true : false
  }

  getPermission () {
    if (!this.hasSupport()) return
    return this.NotificationHandler.permission
  }

  requestPermission (cb) {
    if (!this.hasSupport()) return
    this.NotificationHandler.requestPermission(cb)
  }

  notify (notification) {
    if (!notification) return
    if (!this.hasSupport()) return

    if (this.getPermission() === 'default') {
      return this.requestPermission((permission) => {
        if (permission === 'granted') this.notify(notification)
      })
    }

    let from = notification.from
    if (!this.notifications[from]) this.notifications[from] = []

    let desktopNotif = new this.NotificationHandler(notification.title, {
      icon: notification.icon, body: notification.body, tag: notification.tag
    })

    desktopNotif.onclick = () => {
      window.focus()
      this.markAllAsReadFrom(from)
    }

    this.notifications = update(this.notifications, {[from]: {$push: [desktopNotif]}})

    return desktopNotif
  }

  markAllAsReadFrom (from) {
    if (!this.notifications[from]) return

    this.notifications[from].forEach((notif) => {
      notif.close()
    })
    this.notifications = update(this.notifications, {[from]: {$set: []}})
  }

  markAllAsRead () {
    if (!this.notifications) return

    values(this.notifications).forEach((notifs, from) => {
      this.markAllAsReadFrom(from)
    })
  }
}

export default DesktopNotificationsHandler



/** WEBPACK FOOTER **
 ** ./modules/shared/lib/desktop_notifications_handler.js
 **/